const getters = {
	getListLayananKonsumen: (state) => state.listLayananKonsumen,
	getListLayananOwner: (state) => state.listLayananOwner,
}

export default getters